import { Component } from '@angular/core';
import { BaseMediaPlayerDirective } from 'src/app/directives/base-media-player.directive';

@Component({
  selector: 'app-aws-video-viewer',
  templateUrl: './aws-video-viewer.component.html',
  styleUrls: ['./aws-video-viewer.component.sass'],
})
export class AwsVideoViewerComponent extends BaseMediaPlayerDirective {}
